"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlotIcon = exports.isDefaultIcon = exports.defaultIcons = void 0;

var _react = _interopRequireDefault(require("react"));

var Pin = function Pin(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_358_4977)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.2699 7.62999L10.5899 7.30999C10.7799 7.11999 11.0499 6.99999 11.3199 7.01999C11.9299 7.05999 12.5599 6.82999 12.9899 6.30999C13.6699 5.49999 13.5299 4.26999 12.7799 3.51999L10.3799 1.11999C9.37988 0.119986 8.15988 -0.020014 7.34988 0.659986C6.82988 1.08999 6.59988 1.71999 6.63988 2.32999C6.65988 2.59999 6.53988 2.86999 6.34988 3.05999L6.02988 3.37999C5.79988 3.60999 5.46988 3.72999 5.14988 3.65999C4.02988 3.38999 2.79988 3.72999 1.96988 4.61999C1.36988 5.26999 1.42988 6.29999 2.04988 6.91999L3.32988 8.19999C3.52988 8.39999 3.52988 8.70999 3.32988 8.90999L0.859883 11.38C0.469883 11.77 0.469883 12.4 0.859883 12.79C1.24988 13.18 1.87988 13.18 2.26988 12.79L4.73988 10.32C4.93988 10.12 5.24988 10.12 5.44988 10.32L6.72988 11.6C7.35988 12.23 8.37988 12.29 9.02988 11.68C9.91988 10.85 10.2499 9.61999 9.98988 8.49999C9.91988 8.17999 10.0399 7.84999 10.2699 7.61999V7.62999ZM10.3999 4.66999L8.97988 6.08999C8.78988 6.27999 8.46988 6.28999 8.27988 6.08999L7.56988 5.38999C7.36988 5.19999 7.36988 4.87999 7.56988 4.67999L8.99988 3.24999C9.19988 3.04999 9.50988 3.04999 9.70988 3.24999L10.4199 3.95999C10.6199 4.15999 10.6199 4.46999 10.4199 4.66999H10.3999ZM4.10988 5.59999C4.45988 5.52999 4.84988 5.59999 5.15988 5.82999L7.72988 8.35999L7.81988 8.47999C8.05988 8.78999 8.13988 9.18999 8.05988 9.54999C8.01988 9.74999 7.77988 9.81999 7.63988 9.67999L3.98988 6.02999C3.84988 5.88999 3.91988 5.64999 4.11988 5.60999L4.10988 5.59999Z",
    fill: color !== null && color !== void 0 ? color : "#80849D"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_358_4977"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "14",
    height: "14",
    fill: "white"
  }))));
};

var Star = function Star(_ref2) {
  var color = _ref2.color;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_358_5102)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.91992 13.41C9.59993 13.41 9.28992 13.33 9.00992 13.18L7.00992 12.13L4.99992 13.19C4.35992 13.53 3.54992 13.48 2.94992 13.04C2.34992 12.6 2.04992 11.87 2.17992 11.14L2.55992 8.89997L0.929924 7.30997C0.399924 6.78997 0.209924 6.02997 0.439924 5.31997C0.669924 4.60997 1.26992 4.09997 2.00992 3.99997L4.25992 3.66997L5.26992 1.62997C5.57992 0.989966 6.24992 0.589966 7.00992 0.589966C7.76992 0.589966 8.43992 0.989966 8.74992 1.62997L9.74992 3.66997L11.9999 3.99997C12.7399 4.09997 13.3399 4.60997 13.5699 5.31997C13.7999 6.02997 13.6099 6.78997 13.0799 7.30997L11.4499 8.89997L11.8299 11.14C11.9599 11.87 11.6599 12.6 11.0599 13.04C10.7299 13.28 10.3199 13.41 9.91992 13.41ZM3.13992 6.66997L4.15992 7.65997C4.50992 7.99997 4.66992 8.48997 4.57992 8.95997L4.33992 10.36C4.26992 10.77 4.69992 11.08 5.06992 10.89L6.32992 10.23C6.75992 9.99997 7.26992 9.99997 7.69992 10.23L8.95992 10.89C9.32992 11.08 9.75992 10.77 9.68992 10.36L9.44992 8.95997C9.36992 8.47997 9.52992 7.98997 9.86992 7.65997L10.8899 6.66997C11.1899 6.37997 11.0199 5.87997 10.6099 5.81997L9.19992 5.61997C8.71992 5.54997 8.30992 5.24997 8.08992 4.81997L7.45992 3.53997C7.27992 3.16997 6.74992 3.16997 6.55992 3.53997L5.92992 4.81997C5.71992 5.24997 5.29992 5.54997 4.81992 5.61997L3.40992 5.81997C2.99992 5.87997 2.83992 6.37997 3.12992 6.66997H3.13992Z",
    fill: color !== null && color !== void 0 ? color : "#80849D"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_358_5102"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "14",
    height: "14",
    fill: "white"
  }))));
};

var Warning = function Warning(_ref3) {
  var color = _ref3.color;
  var brandColor = color !== null && color !== void 0 ? color : "#80849D";
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_358_5088)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 7V4",
    stroke: brandColor,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11Z",
    fill: brandColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 2C4.24 2 2 4.24 2 7C2 9.76 4.24 12 7 12C9.76 12 12 9.76 12 7C12 4.24 9.76 2 7 2Z",
    fill: brandColor
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_358_5088"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "14",
    height: "14",
    fill: "white"
  }))));
};

var Bookmark = function Bookmark(_ref4) {
  var color = _ref4.color;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11 0.380005H3C1.9 0.380005 1 1.28 1 2.38V11.49C1 12.23 1.34 12.96 1.98 13.34C2.3 13.53 2.65 13.62 3 13.62C3.35 13.62 3.71 13.52 4.03 13.33L6.49 11.86C6.81 11.67 7.2 11.67 7.52 11.86L9.98 13.33C10.3 13.52 10.65 13.62 11.01 13.62C11.37 13.62 11.71 13.53 12.03 13.34C12.67 12.97 13.01 12.23 13.01 11.49V2.38C13.01 1.28 12.11 0.380005 11.01 0.380005H11ZM11 10.73C11 11.12 10.58 11.36 10.24 11.16L8.03 9.83C7.71 9.64001 7.36 9.54 7 9.54C6.64 9.54 6.29 9.64001 5.97 9.83L3.76 11.16C3.43 11.36 3 11.12 3 10.73V2.88C3 2.6 3.22 2.38 3.5 2.38H10.5C10.78 2.38 11 2.6 11 2.88V10.73Z",
    fill: color !== null && color !== void 0 ? color : "#80849D"
  }));
};

var defaultIcons = {
  "default": Pin,
  bookmark: Bookmark,
  warning: Warning,
  star: Star
};
exports.defaultIcons = defaultIcons;

var isDefaultIcon = function isDefaultIcon(icon) {
  return Boolean(defaultIcons[icon]);
};

exports.isDefaultIcon = isDefaultIcon;

var SlotIcon = function SlotIcon(_ref5) {
  var color = _ref5.color,
      icon = _ref5.icon;

  switch (icon) {
    case "default":
    case "warning":
    case "star":
    case "bookmark":
      {
        var Icon = defaultIcons[icon];
        return /*#__PURE__*/_react["default"].createElement(Icon, {
          color: color
        });
      }
  }

  return /*#__PURE__*/_react["default"].createElement("img", {
    alt: "pinned message",
    src: icon
  });
};

exports.SlotIcon = SlotIcon;